import { render, staticRenderFns } from "./VendedorModal.vue?vue&type=template&id=39473f5c&scoped=true"
import script from "./VendedorModal.vue?vue&type=script&lang=js"
export * from "./VendedorModal.vue?vue&type=script&lang=js"
import style0 from "./VendedorModal.vue?vue&type=style&index=0&id=39473f5c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39473f5c",
  null
  
)

export default component.exports